/* eslint-disable @typescript-eslint/no-explicit-any */
import DayRangeSelect from '@app/components/Shares/Select/DayRangeSelect';
import { MergedProperty } from '../../types';

interface DayRangeItemProps {
    item: MergedProperty;
    colClass: string;
    onChange: (value: any, code: string) => void;
}

const DayRangeItem = ({ item, colClass, onChange }: DayRangeItemProps) => {
    const dayValue = `${item.ps_value}`;

    return (
        <div className={`${colClass} col-sm-6`}>
            <div className="form-group">
                <label>
                    <h6 className="panel-title">{item.p_name}</h6>
                </label>
                <DayRangeSelect
                    defaultValue={dayValue}
                    onChange={(val) => onChange(val, item.ps_code)}
                />
            </div>
        </div>
    );
};

export default DayRangeItem;
